import {PropsWithChildren} from 'react';
import {Toaster} from "react-hot-toast";
import Header from "@/Layouts/Guest/Header";
import Footer from "@/Layouts/Guest/Footer";
import {usePage, Head} from "@inertiajs/react";
import {PageProps} from "@/types";
import useSessionToast from "@/utils/useSessionToast";
import useTranslations from "@/hooks/useTranslations";

export default function GuestLayout({children}: PropsWithChildren) {
    const pageProps = usePage<PageProps>().props;
    const {sessionFlash} = pageProps;
    const {locale, alternateUrls} = useTranslations()

    useSessionToast(sessionFlash);

    return (
        <div className="bg-white dark:bg-gray-900">
            {alternateUrls && (
                <Head>
                    {Object.entries(alternateUrls).map(([lang, url]) => (
                        <link key={lang} rel="alternate" hrefLang={lang} href={url as string} />
                    ))}
                    <link rel="alternate" hrefLang="x-default" href={alternateUrls.en as string} />
                    <link rel="canonical" href={alternateUrls[locale]} />
                </Head>
            )}
            <div
                className="relative sm:items-center min-h-[70vh]  bg-center bg-white dark:bg-gray-900 selection:bg-orange-500 selection:text-white">
                <Header/>
                {children}
            </div>
            <div className="xl:px-10 bg-white dark:bg-gray-900">
                <Footer/>
            </div>
            <Toaster/>
        </div>
    );
}
